import type { PayLetterPaymentMethod } from '../../../domains/orders/services/orderServices';

export type PayLetterPaymentMethodOption = {
  value: PayLetterPaymentMethod;
  label: string;
  subLabel: string;
  imgSrc: string;
};

export const PAY_LETTER_PAYMENT_METHOD_OPTIONS: PayLetterPaymentMethodOption[] = [
  {
    value: 'creditcard',
    label: '신용카드',
    subLabel: 'CARD',
    imgSrc: '/assets/payments/credit_card.png'
  },
  {
    value: 'kakaopay',
    label: '카카오페이',
    subLabel: 'KAKAO PAY',
    imgSrc: '/assets/payments/kakao_pay.png'
  },
  {
    value: 'payco',
    label: '페이코',
    subLabel: 'PAYCO',
    imgSrc: '/assets/payments/payco.png'
  },
  {
    value: 'checkpay',
    label: '체크페이',
    subLabel: 'CHECKPAY',
    imgSrc: '/assets/payments/check_pay.png'
  },
  {
    value: 'toss',
    label: '토스',
    subLabel: 'TOSS',
    imgSrc: '/assets/payments/toss_pay.png'
  },
  {
    value: 'ssgpay',
    label: 'SSG페이',
    subLabel: 'SSGPAY',
    imgSrc: '/assets/payments/ssg_pay.png'
  },
  {
    value: 'samsungpay',
    label: '삼성페이',
    subLabel: 'SAMSUNG PAY',
    imgSrc: '/assets/payments/samsung_pay.png'
  },
  {
    value: 'applepay',
    label: '애플페이',
    subLabel: 'APPLE PAY',
    imgSrc: '/assets/payments/apple_pay.png'
  }
];
